"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buy = exports.removeFromListing = exports.addToListing = exports.getCollections = void 0;
const response_formatters_1 = require("../response-formatters");
exports.getCollections = {
    response: (response) => {
        if (!response.length) {
            return [];
        }
        return response.map((collectionInfo) => {
            return (0, response_formatters_1.deserializeCollection)(collectionInfo);
        });
    }
};
exports.addToListing = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            price: [params.price],
            seller: [],
            version: [],
            fungible_id: [],
            caller: [],
            buyer: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.removeFromListing = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            price: [],
            seller: [],
            version: [],
            fungible_id: [],
            caller: [],
            buyer: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.buy = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            price: [],
            seller: [],
            version: [],
            fungible_id: [],
            caller: [],
            buyer: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
